import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'


import Home from '@/modules/home/index.vue';

//import routes(lazy)
const Contacts = () => import('@/modules/contacts/index.vue');
const Category = () => import('@/modules/categories/index.vue');
const Card = () => import('@/modules/card/index.vue');
const Faq = () => import('@/modules/faq/index.vue');
const Registration = () => import('@/modules/auth/registration/index.vue');
const SingIn = () => import('@/modules/auth/sing-in/index.vue');
const ActivationEmail = () => import('@/modules/activation-email/index.vue');
const RestorePassword = () => import('@/modules/auth/restore-password/index.vue');
const SetNewPassword = () => import('@/modules/auth/set-new-password/index.vue');
const ResultSearch = () => import('@/modules/result-search/index.vue');
const Basket = () => import('@/modules/basket/index.vue');
const CreateOrder = () => import('@/modules/create-order/index.vue');
const PropsSelection = () => import('@/modules/props-selection/index.vue');
const FavoritesNonAuth = () => import('@/modules/favorites-non-auth/index.vue');
const PageNotFound = () => import('@/modules/page-not-found/index.vue');
const ServerNotFound = () => import('@/modules/server-not-found/index.vue');

const FavoritesShared = () => import('@/modules/favorites-shared/index.vue');

//profile
const Favorites = () => import('@/modules/profile/pages/favorites/index.vue');
const Setting = () => import('@/modules/profile/pages/setting/index.vue');
const History = () => import('@/modules/profile/pages/history/index.vue');
const Orders = () => import('@/modules/profile/pages/orders/index.vue');
const Profile = () => import('@/modules/profile/index.vue');

Vue.use(Router);

const isAuthenticated = (to, from, next) => {
    if (store.state.auth.isAuthenticated) {
        next();
        return
    }
    next('/')
};

const isNotAuthenticated = (to, from, next) => {
    if (!store.state.auth.isAuthenticated) {
        next();
        return
    }
    next('/')
};


const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:lang(.{2})?/',
            name: 'home',
            component: Home,
        },
        {
            path: '/:lang(.{2})?/',
            name: 'activation',
            component: Home,
        },
        {
            path: '/:lang?/not-found',
            name: 'not-found',
            component: PageNotFound,
        },
        {
            path: '/:lang?/server-not-found',
            name: 'server-not-found',
            component: ServerNotFound,
        },
        {
            path: '/:lang?/categories/:slug',
            name: 'categories',
            component: Category,
        },
        {
            path: '/:lang?/favorites/shared/:slug',
            name: 'favorites.shared',
            component: FavoritesShared,
        },
        {
            path: '/:lang?/categories/:slug/card/:item',
            name: 'card',
            component: Card,
        },
        {
            path: '/:lang?/faq',
            name: 'faq',
            component: Faq,
        },
        {
            path: '/:lang?/contacts',
            name: 'contacts',
            component: Contacts,
        },
        {
            path: '/:lang?/basket',
            name: 'basket',
            component: Basket,
        },
        {
            path: '/:lang?/basket/create-order',
            name: 'create-order',
            component: CreateOrder,
        },
        {
            path: '/:lang?/props-selection',
            name: 'props-selection',
            component: PropsSelection,
        },
        {
            path: '/:lang?/registration',
            name: 'registration',
            component: Registration,
            beforeEnter: isNotAuthenticated,
        },
        {
            path: '/:lang?/activation-email',
            name: 'activation-email',
            component: ActivationEmail
        },
        {
            path: '/:lang?/sing-in',
            name: 'sing-in',
            component: SingIn,
            beforeEnter: isNotAuthenticated,
        },
        {
            path: '/:lang?/restore-password',
            name: 'restore-password',
            component: RestorePassword,
            beforeEnter: isNotAuthenticated,
        },
        {
            path: '/:lang?/set-new-password',
            name: 'set-new-password',
            component: SetNewPassword,
        },
        {
            path: '/:lang?/favorites',
            name: 'favorites-non-auth',
            component: FavoritesNonAuth,
        },
        {
            path: '/:lang?/search-result',
            name: 'search-result',
            component: ResultSearch,
        },
        {
            path: '/:lang?/',
            name: 'profile',
            component: Profile,
            beforeEnter: isAuthenticated,
            children: [
                {
                    path: '/:lang?/profile',
                    name: 'setting',
                    component: Setting,
                },
                {
                    path: '/:lang?/profile/favorites',
                    name: 'favorites',
                    component: Favorites,
                },
                {
                    path: '/:lang?/profile/history',
                    name: 'history',
                    component: History,
                },
                {
                    path: '/:lang?/profile/orders',
                    name: 'orders',
                    component: Orders,
                },
            ]
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        let el = document.querySelector('.app');
        if (to.path !== from.path && !to.fullPath.includes('profile')) {
            if (savedPosition) {
                return savedPosition
            } else {
                el.scrollLeft = 0;
                el.scrollTop = 0;

                return {x: 0, y: 0}
            }
        }
    }
});

router.beforeEach((to, from, next) => {
    store.state.system.openMenu = false;
    const body = document.querySelector('body');
    body.classList.remove('fix');
    if (!to.matched.length) {
        next('/not-found');
        next();
    } else {
        // if(!router.history.current.path.includes('categories')){
        //     window.scroll({
        //         top: 0,
        //         left: 0,
        //         behavior: 'smooth'
        //     });
        // }
        next();
    }

});
export default router;
